module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('app-nav'), _vm._v(" "), _c('introduction-section'), _vm._v(" "), _c('map-section'), _vm._v(" "), _c('conclusion-section'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "embed-form",
      "height": "auto",
      "adaptive": true,
      "pivotY": 0.1
    }
  }, [_c('embed-form', {
    staticClass: "px-4 py-3"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0070f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 782
// module chunks = 1